<ng-container *ngIf="state$ | async as state">
  <ng-container *ngIf="state.image">
    <div [attr.aria-label]="caption?.value?.trim()?.length ? undefined : 'image'"
         class="modal-header modal-padding"
         data-cy="image-modal-header"
    >
      <button (click)="close()"
              aria-label="Close"
              class="close"
              data-cy="image-modal-close-button"
              data-dismiss="modal"
              type="button"
      >
        <span aria-hidden="true"
              data-cy="image-modal-close-text"
              [innerHTML]="'×'"
        ></span>
      </button>
      <div *ngIf="caption?.value?.trim()?.length"
           [data-preview-id]="'#' + caption?.name"
           [id]="'headline-' + id"
           [innerHTML]="caption?.value | safeHtml"
           data-cy="image-modal-headline"
           mbCmsInnerHTML
      ></div>
    </div>
    <div class="modal-body modal-padding"
         data-cy="image-modal-body"
    >
      <ng-container *ngIf="state.modalImage">
        <mb-picture [img]="state.modalImage"
                    [imgClass]="'img-responsive w-100'"
                    [srcSet]="[{ mediaQuery: mediaQuery.MIN_WIDTH_1200, url1x: state.modalImage.xl, url2x: state.modalImage.xl2x },
                               { mediaQuery: mediaQuery.MIN_WIDTH_992, url1x: state.modalImage.lg, url2x: state.modalImage.lg2x },
                               { mediaQuery: mediaQuery.MIN_WIDTH_768, url1x: state.modalImage.md, url2x: state.modalImage.md2x },
                               { mediaQuery: mediaQuery.MIN_WIDTH_500, url1x: state.modalImage.sm, url2x: state.modalImage.sm2x },
                               { mediaQuery: mediaQuery.MAX_WIDTH_499, url1x: state.modalImage.xs, url2x: state.modalImage.xs2x }]"
                    dataCy="image-modal-image"
        ></mb-picture>
      </ng-container>
    </div>
    <div class="modal-footer"
         data-cy="image-modal-footer"
    >
      <div *ngIf="description?.value?.length"
           [data-preview-id]="'#' + description?.name"
           [id]="'description-' + id"
           [innerHTML]="description?.value | safeHtml"
           mbCmsInnerHTML
      ></div>
    </div>
  </ng-container>
</ng-container>
